import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {HospitalType} from "../../generated-model/model";
import {first, Observable, shareReplay} from "rxjs";

@Injectable({providedIn: "root"})
export class HospitalTypeResource {
  http = inject(HttpClient);
  hospitalType$: Observable<HospitalType[]>

  constructor() {
    this.hospitalType$ = this.http.get<HospitalType[]>('api/hospital-type')
      .pipe(shareReplay(1), first())
  }
}
